import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

export const initState = {
  status: 'init', // idle -> loading -> loaded
  mode: 'preview', // preview | select
  selectedIds: [], // preview | select
  medias: [],

  // pixabay search
  searchquery: '',
  searchstatus: 'idle', // idle -> searching -> idle
  pixabay: [],
  pixabayMedia: null,
};

export const galleryReducer = createReducer(initState, {
  [ActionTypes.GALLERY_GET_REQUEST](state) {
    return update(state, {
      medias: { $set: [] },
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.GALLERY_GET_SUCCESS](state, { payload }) {
    return update(state, {
      medias: { $set: payload.medias },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.GALLERY_GET_FAILURE](state) {
    return update(state, {
      medias: { $set: [] },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.GALLERY_DELETE_REQUEST](state) {
    return update(state, {
      mode: { $set: 'preview' },
      selectedIds: { $set: [] },
      medias: {
        $apply: (medias) => (
          medias.filter(media => (
            !(('selected' in media) && (media.selected === true))
          ))
        ),
      },
    });
  },

  [ActionTypes.GALLERY_DELETE_SUCCESS](state) {
    return update(state, {
      status: { $set: 'loaded' },
    });
  },

  [ActionTypes.GALLERY_DELETE_FAILURE](state) {
    return state;
  },

  [ActionTypes.GALLERY_CLICK_REQUEST](state, { payload }) {
    const { mediaUrlsafe } = payload;
    const index = state.medias.findIndex(x => x.urlsafe === mediaUrlsafe);
    if (index === -1) {
      return state;
    }

    const clickedMedia = state.medias[index];
    const isSelected = ('selected' in clickedMedia && clickedMedia.selected === true);
    const nextState = update(state, {
      medias: {
        [index]: {
          selected: { $set: !isSelected },
        },
      },
    });

    const selectedIds = nextState.medias.reduce((prev, media) => {
      if ('selected' in media && media.selected === true) {
        prev.push(media.urlsafe);
      }
      return prev;
    }, []);

    if (selectedIds.length === 0) {
      return update(nextState, {
        mode: { $set: 'preview' },
        selectedIds: { $set: [] },
      });
    }
    // else
    return update(nextState, {
      mode: { $set: 'select' },
      selectedIds: { $set: selectedIds },
    });
  },

  [ActionTypes.GALLERY_UPLOAD_STATUS_CHANGE](state, { payload }) {
    const { change } = payload;
    const { file } = change;

    if (file) {
      const { uid } = file;
      let index = state.medias.findIndex(x => x.uid === uid);
      let nextState = null;
      let nextFile = null;
      if (file.status === 'done') {
        const { response } = file;
        if (response.status === 'success') {
          [nextFile] = response.result.files;
        }
      }
      if (nextFile === null) {
        nextFile = file;
      }

      if (index === -1) {
        nextState = update(state, {
          medias: { $unshift: [nextFile] },
        });
        index = 0;
      }
      else {
        nextState = update(state, {
          medias: {
            [index]: { $set: nextFile },
          },
        });
      }
      return nextState;
    }
    return state;
  },
  [ActionTypes.GALLERY_EXIT_SELECT_MODE](state) {
    return update(state, {
      mode: { $set: 'preview' },
      selectedIds: { $set: [] },
      medias: {
        $apply: medias => medias.map(media => update(media, {
          selected: { $set: false },
        })),
      },
    });
  },
  [ActionTypes.GALLERY_PIXABAY_SEARCH_REQUEST](state, { payload }) {
    const { term } = payload;
    return update(state, {
      searchquery: { $set: term },
      searchstatus: { $set: 'searching' },
      pixabay: { $set: [] },
    });
  },
  [ActionTypes.GALLERY_PIXABAY_SEARCH_SUCCESS](state, { payload }) {
    return update(state, {
      searchstatus: { $set: 'idle' },
      pixabay: { $set: JSON.parse(payload) },
    });
  },
  [ActionTypes.GALLERY_PIXABAY_SEARCH_FAILURE](state) {
    return state;
  },
  [ActionTypes.GALLERY_ADDFROM_PIXABAY_REQUEST](state) {
    return state;
  },
  [ActionTypes.GALLERY_ADDFROM_PIXABAY_SUCCESS](state, { payload }) {
    const { newMedia } = payload;
    return update(state, {
      medias: { $unshift: [newMedia] },
      pixabayMedia: { $set: newMedia },
    });
  },
  [ActionTypes.GALLERY_ADDFROM_PIXABAY_FAILURE](state) {
    return state;
  },

  [ActionTypes.GALLERY_USE_PIXABAY_REQUEST](state) {
    return update(state, {
      pixabayMedia: { $set: null },
    });
  },
});



// WEBPACK FOOTER //
// ./scripts/reducers/gallery.js